import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';

export const useQuoteSummaryHeaderStyles = createStyles(({ token }) => ({
  quoteButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: ThemeSpaces.SPACE_NORM_30,
    borderRadius: token.borderRadius,
    boxShadow: `6px 6px 20px ${ThemeColors.COLOR_GREY7_75}`,
  },
  quoteButton: {
    padding: '29px 0',
    color: token.colorWhite,
    font: `700 ${token.fontSizeHeading2}px ${ThemeFont.FONT_CONDENSED}`,
    textAlign: 'center',
  },
  saveButton: {
    display: 'flex',
    width: '15%',
    textAlign: 'center',
    color: ThemeColors.COLOR_GREY3,
    font: `500 19px ${token.fontFamily}`,
    flexDirection: 'row',

    [`@media (max-width: ${token.screenXLMax}px)`]: {
      fontSize: token.fontSizeHeading4,
      width: 'auto',
      flexBasis: 170,
    },
    [`@media (max-width: ${token.screenLGMax}px)`]: {
      fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
      width: 'auto',
      flexBasis: 150,
    },
    [`@media (max-width: ${token.screenMDMax}px)`]: {
      fontSize: token.fontSize,
      width: 'auto',
      flexBasis: 140,
    },

    borderRadius: `${token.borderRadiusSM}px 0 0 ${token.borderRadiusSM}px`,
  },
  continueButton: {
    width: '70%',
    backgroundColor: token.colorPrimary,
    color: token.colorWhite,
    font: `700 ${token.fontSizeHeading2}px ${ThemeFont.FONT_CONDENSED}`,
    textAlign: 'center',
    borderRadius: 0,

    [`@media (max-width: ${token.screenXLMax}px)`]: {
      width: 'auto',
      flexBasis: 610,
      flexGrow: 1,
      fontSize: token.fontSizeHeading3,
    },
    [`@media (max-width: ${token.screenLGMax}px)`]: {
      flexBasis: 525,
    },
    [`@media (max-width: ${token.screenMDMax}px)`]: {
      width: 'auto',
      flexBasis: 240,
      flexGrow: 1,
      fontSize: token.fontSizeLG,
    },
  },
  cancelButton: {
    display: 'flex',
    width: '15%',
    textAlign: 'center',
    color: ThemeColors.COLOR_GREY3,
    font: `500 19px ${token.fontFamily}`,
    flexDirection: 'row',

    '.far': {
      color: ThemeColors.COLOR_RED2,
      fontSize: token.fontSizeHeading4,
    },

    [`@media (max-width: ${token.screenXLMax}px)`]: {
      fontSize: token.fontSizeHeading4,
      width: 'auto',
      flexBasis: 170,
    },
    [`@media (max-width: ${token.screenLGMax}px)`]: {
      fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
      width: 'auto',
      flexBasis: 150,
    },
    [`@media (max-width: ${token.screenMDMax}px)`]: {
      fontSize: token.fontSize,
      width: 'auto',
      flexBasis: 140,
    },

    borderRadius: `0 ${token.borderRadiusSM}px ${token.borderRadiusSM}px 0`,
  },
  price: {
    textAlign: 'right',
  },
}));
